export default {
    exhibitions: [],
    artworks: [],
    awards: [],
    sketchADays: [],
    ajaxCallsInProgress: 0
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js